// services/api/es.js
import requestApi from './api';

function getAllData(state: any) {
  let es_query: any = {};
  let es_sorting: any = [];
  let es_filters: any = [];

  if (state.filterParams.length !== 0) {
    state.filterParams.forEach((k: any) => {
      const objKey = Object.getOwnPropertyNames(k)[0];
      if (objKey === "french_pea") {
        es_filters.push({ match: { [objKey]: 1 } });
      }
    });

    if (es_filters.length !== 0) {
      es_query.bool = {};
      es_query.bool.must = es_filters;
    }
  }

  if (state.filterCategories.length !== 0) {
    state.filterCategories.forEach((k:any) => {
      const objKey: any = Object.getOwnPropertyNames(k)[0];
      let objSort: any = {};
      if (objKey.includes("performance_end_of_month")) {
        objSort[objKey] = { order: "desc" };
        es_sorting.push(objSort);
      } else {
        es_filters.push({ match: k });
      }
    });
  }

  if (state.filterSubCategories.length !== 0) {
    state.filterSubCategories.forEach((k:any) => {
      switch (Object.keys(k)[0]) {
        case "performance_end_of_month_5_years":
        case "performance_end_of_month_10_years":
        case "management_fee":
          if(state.tableTaxo) {
            let current_taxo = state.tableTaxo[Object.keys(k)[0]];
            if(current_taxo) {
              let range: any = {};
              let current_bucket = _.find(current_taxo.buckets, [
                "key",
                Object.values(k)[0]
              ]);
              if (current_bucket.from) {
                if (current_bucket.to) {
                  range[Object.keys(k)[0]] = {
                    "gte": current_bucket.from,
                    "lte": current_bucket.to
                  }
                  es_filters.push({
                    range: range
                  });
                } else {
                  range[Object.keys(k)[0]] = {
                    "gte": current_bucket.from
                  };
                  es_filters.push({
                    range: range
                  });
                }
              } else if (current_bucket.to) {
                range[Object.keys(k)[0]] = {
                  "lte": current_bucket.to
                };
                es_filters.push({
                  range: range
                });
              }

            }
          }
          break;
        case "creation_date":
          if(state.tableTaxo) {
            let current_taxo = state.tableTaxo[Object.keys(k)[0]];
            if(current_taxo) {
              let range: any = {};
              let current_bucket = _.find(current_taxo.buckets, [
                "key",
                Object.values(k)[0]
              ]);
              range[Object.keys(k)[0]] = {
                "gte": current_bucket.key_as_string + '-01-01',
                "lte": current_bucket.key_as_string + '-12-31'
              }
              es_filters.push({
                range: range
              });
            }
          }
          break;
        // case "rating":
        //   console.log(k);
        //   let currentRating = k.rating == -1 ? {rating: null} : k;          
        //   es_filters.push({ match: currentRating });
        //   break;
        default:
          es_filters.push({ match: k });
      }

    });
  }

  if (es_query.bool === undefined && es_filters.length !== 0) {
    es_query.bool = {};
  }
  if (es_query.bool !== undefined && es_filters.length !== 0) {
    es_query.bool.must = es_filters;
  }

  if (state.searchPattern && state.searchPattern != "") {
    if (es_query.bool === undefined) {
      es_query.bool = {};
      es_query.bool.must = [];
    }
    es_query.bool.must.push({
      match: { isin: { query: state.searchPattern, fuzziness: 0 } }
    });
  }

  if (es_filters.length === 0 && !state.searchPattern) {
    es_query.match_all = {};
  }

  if (es_sorting.length !== 0) {
    es_sorting.push({ _score: { order: "desc" } });
  }

  let es_paginate: any = {};
  if (state.filterCurrentSize !== 0) {
    es_paginate.size = state.filterSize;
    es_paginate.from = state.filterCurrentPage;
  }

  // console.log("es_query getFilters", {
  //   size: state.filterSize,
  //   from: state.filterCurrentPage,
  //   query: es_query,
  //   sort: es_sorting
  // });

  return requestApi({
    url: `/funds/_search`,
    method: "POST",
    auth: {
      username: "data_reader",
      password: "tiesaenu0Fae"
    },
    headers: {
      "Content-Type": "application/json"
    },
    data: {
      size: state.filterSize,
      from:
        state.filterCurrentPage == 1
          ? 0
          : (state.filterCurrentPage - 1) * state.filterSize,
      query: es_query,
      sort: es_sorting,
      aggs: {
        "advisor.raw": {
          terms: {
            field: "advisor.raw",
            size: 1000,
            order: { _key: "asc" },
            missing: "N/A"
          }
        },
        "l1_category.raw": {
          terms: {
            field: "l1_category.raw",
            size: 1000,
            order: { _key: "asc" },
            missing: "N/A"
          }
        },
        // "general_category.raw": {
        //   terms: {
        //     field: "general_category.raw",
        //     size: 1000,
        //     order: { _count: "desc" },
        //     missing: "N/A"
        //   }
        // },
        "geo_category.raw": {
          terms: {
            field: "geo_category.raw",
            size: 1000,
            order: { _key: "asc" },
            missing: "N/A"
          }
        },
        "provider.raw": {
          terms: {
            field: "provider.raw",
            size: 1000,
            order: { _key: "asc" },
            missing: "N/A"
          }
        },
        rating: {
          terms: {
            field: "rating",
            size: 1000,
            order: { _key: "asc" },
            missing: "-1"
          }
        },
        management_fee: {
          range: {
            field: "management_fee",
            ranges: [
              {
                to: -10
              },
              {
                from: -9,
                to: -5
              },
              {
                from: -4,
                to: 0
              },
              {
                from: 1,
                to: 2
              },
              {
                from: 3,
                to: 5
              },
              {
                from: 6,
                to: 8
              },
              {
                from: 9,
                to: 11
              },
              {
                from: 12,
                to: 13
              },
              {
                from: 14,
                to: 17
              },
              {
                from: 17
              }
            ]
          }
        },
        creation_date: {
          date_histogram: {
            field: "creation_date",
            calendar_interval: "year",
            format: "yyyy",
            order: { _key: "desc" }
          }
        },
        performance_end_of_month_5_years: {
          range: {
            field: "performance_end_of_month_5_years",
            ranges: [
              {
                to: -15
              },
              {
                from: -15,
                to: -10
              },
              {
                from: -10,
                to: -7
              },
              {
                from: -7,
                to: -5
              },
              {
                from: -5,
                to: -3
              },
              {
                from: -3,
                to: -1.5
              },
              {
                from: -1.5,
                to: -0.5
              },
              {
                from: -0.5,
                to: 0.5
              },
              {
                from: 0.5,
                to: 1.5
              },
              {
                from: 1.5,
                to: 3
              },
              {
                from: 3,
                to: 5
              },
              {
                from: 5,
                to: 7
              },
              {
                from: 7,
                to: 10
              },
              {
                from: 10,
                to: 15
              },
              {
                from: 15,
                to: 25
              },
              {
                from: 25,
                to: 50
              },
              {
                from: 50
              }
            ]
          }
        },
        performance_end_of_month_10_years: {
          range: {
            field: "performance_end_of_month_10_years",
            ranges: [
              {
                to: -15
              },
              {
                from: -15,
                to: -10
              },
              {
                from: -10,
                to: -7
              },
              {
                from: -7,
                to: -5
              },
              {
                from: -5,
                to: -3
              },
              {
                from: -3,
                to: -1.5
              },
              {
                from: -1.5,
                to: -0.5
              },
              {
                from: -0.5,
                to: 0.5
              },
              {
                from: 0.5,
                to: 1.5
              },
              {
                from: 1.5,
                to: 3
              },
              {
                from: 3,
                to: 5
              },
              {
                from: 5,
                to: 7
              },
              {
                from: 7,
                to: 10
              },
              {
                from: 10,
                to: 15
              },
              {
                from: 15,
                to: 25
              },
              {
                from: 25,
                to: 50
              },
              {
                from: 50
              }
            ]
          }
        }
      }
    }
  });
};

const ServiceElastic = {
  getAllData
};

export default ServiceElastic;
